import React, { useState } from "react";
import styled from "styled-components";
import { SkinId } from "../../../skins/types";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
import { Icon } from "../../Icon";
const StylableCopyToClipboard = ({ className, description, item, successText }) => {
    const [copySuccess, setCopySuccess] = useState(false);
    const handleClick = async () => {
        try {
            await navigator.clipboard.writeText(item);
            setCopySuccess(true);
            setTimeout(() => {
                setCopySuccess(false);
            }, 4000);
        }
        catch (err) {
            setCopySuccess(false);
        }
    };
    return (React.createElement("div", { className: className, "data-testid": "copy-to-clipboard" },
        description && React.createElement("p", { className: "copy-to-clipboard_description" }, description),
        React.createElement("div", { className: "copy-to-clipboard_item", "data-testid": "copy-to-clipboard_item", onClick: handleClick },
            React.createElement(Icon, { name: "linkUrl" }),
            " ",
            React.createElement("span", null, item)),
        React.createElement("div", { className: "copy-to-clipboard_success", "data-testid": "copy-to-clipboard_success", style: {
                opacity: copySuccess ? "1" : "0",
            } },
            React.createElement(Icon, { name: "checkmark" }),
            React.createElement("span", null, successText))));
};
export const CopyToClipboard = styled(StylableCopyToClipboard) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=CopyToClipboard.js.map